import moment from "moment";

export interface CellInterface {
  cladire?: string | null;
  rand?: string | null;
  coloana?: string | null;
  polita?: string | null;
  celula?: string | null;
  alee?: string | null;
  insula?: string | null;
  alias?: string | null;
  [key: string]: unknown;
}

export interface BoxCodeDataInterface {
  node: string;
  op: string;
  box: string;
  deliveryPoint?: string;
}

export const getRecomandedCell = (cellData?: CellInterface | null) => {
  if (!cellData) {
    return "";
  }
  const cellWithAlias = cellData?.alias;

  let cellLabel = "";

  const cellComposition = [
    "cladire",
    "rand",
    "coloana",
    "polita",
    "celula",
    "alee",
    "insula",
  ];

  // ex C01.R01.K04
  if (cellWithAlias) {
    return cellWithAlias;
  }

  cellComposition.forEach((item, idx) => {
    // @ts-ignore
    const cellValue = cellData?.[item];
    if (cellValue) {
      const cellName = idx === 0 ? cellValue : `-${cellValue}`;
      cellLabel = cellLabel + cellName;
    }
  });

  return cellLabel;
};

export const getCellScanned = (scannerValue: number | string) => {
  const parseScannerValue = scannerValue.toString();
  if (!parseScannerValue) {
    return null;
  }

  if (parseScannerValue[0] === "C" || parseScannerValue[0] === "D") {
    if (
      parseScannerValue.split("-").length >= 3 ||
      parseScannerValue.split(".").length >= 2
    ) {
      return parseScannerValue;
    }
  }
  return null;
};

export const getCellFromString = (cellString: string) => {
  const cellArrayData = cellString.split("-");
  let cellData = {
    cladire: "",
    rand: "",
    coloana: "",
    polita: "",
    celula: "",
    alee: "",
    insula: "",
  };

  cellArrayData.forEach((item) => {
    switch (item[0]) {
      case "D":
        cellData = { ...cellData, cladire: item };
        break;
      case "R":
        cellData = { ...cellData, rand: item };
        break;
      case "K":
        cellData = { ...cellData, coloana: item };
        break;
      case "P":
        cellData = { ...cellData, polita: item };
        break;
      case "C":
        cellData = { ...cellData, celula: item };
        break;
      case "A":
        cellData = { ...cellData, alee: item };
        break;
      case "I":
        cellData = { ...cellData, insula: item };
        break;

      default:
        break;
    }
  });

  return cellData;
};

export const isCellCodeValid = (cellString: string | number) => {
  const cellStringData = cellString.toString();
  if (!cellStringData) {
    return false;
  }

  const cellWithAliasFirstCharCheck = cellStringData[0] === "C";
  const cellWithoutAliasFirstCharCheck = cellStringData[0] === "D";

  const checkScannedValueWithAlias =
    cellStringData.split(".").length === 3 && cellWithAliasFirstCharCheck;
  const checkScannedValueWithoutAlias =
    cellStringData.split("-").length >= 5 && cellWithoutAliasFirstCharCheck;

  if (checkScannedValueWithAlias) {
    return true;
  } else if (checkScannedValueWithoutAlias) {
    return true;
  } else {
    return false;
  }
};

export const getBoxCodeData = (boxString: string | number) => {
  const boxStringData = boxString.toString()?.split("*");
  if (boxStringData.length > 2) {
    return {
      boxString: boxString.toString(),
      node: boxStringData[0]?.trim(),
      op: boxStringData[1]?.trim(),
      box: boxStringData[2]?.trim(),
      tip: boxStringData[3]?.trim(),
    };
  }
  return null;
};

export const getBinCodeData = (binString: string | number) => {
  const binStringData = binString.toString()?.split("-");

  const binData =
    binStringData[1]?.trim() === "YMD"
      ? moment().format("YYYYMMDD")
      : binStringData[1]?.trim();
  if (binStringData.length > 2) {
    return {
      binString: binString.toString(),
      node: binStringData[0]?.trim(),
      data: binData,
      idBarCode: binStringData[2]?.trim(),
      increment: binStringData[3]?.trim(),
    };
  }
  return null;
};
